/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

!(function() {
  var m = require('mobx');
  const { uniqueId, isEmpty, forEach, some, map, uniq, find } = require('lodash/fp');
  var { STATE, ACCESSIBLE_VALUE_OPTIONS } = require('logic/data/Izenda.SecurityRulesConstants');

  function SecurityRule(data) {
    var props = {
      tempId: uniqueId('securityRule_'),
      id: null,
      state: STATE.none,
      position: null,
      userGroup: null,
      accessors: [],
      accessibleValues: [],
      accessMode: null,
      accessibleValuesInfo() {
        return map(value => {
          return find(option => option.value === value, ACCESSIBLE_VALUE_OPTIONS)
            || { label: value, value: value};
        }, this.accessibleValues);
      },
      accessorsInfo() {
        return this.accessors.sort();
      }
    };

    m.extendObservable(this, props);

    data && this.readSecurityRule(data);
  }
 
  SecurityRule.prototype.readSecurityRule = m.action(function(data) {
    this.id = data.id;
    this.state = data.state,
    this.position = data.position;
    this.userGroup = data.userGroup;
    this.accessors = data.accessors;
    this.accessibleValues = data.accessibleValues;
    this.accessMode = data.accessMode;
  }); 

  SecurityRule.prototype.updateUserGroup = m.action(function(userGroup) {
    this.userGroup = userGroup;
    this.clearAccessors();
    this.markAsUpdated();
  });

  SecurityRule.prototype.addAccessors = m.action(function(newAccessors) {
    forEach(item => {
      if (!isEmpty(item) && !some(accessor => accessor.id === item.id, this.accessors)) {
        var newItem = {
          id: item.id,
          name: item.name || item.fullName
        }
        this.accessors.push(newItem);
      }
    }, newAccessors);
    this.markAsUpdated();
  });

  SecurityRule.prototype.updateAccessors = m.action(function(accessors) {
    this.accessors = accessors;
    this.markAsUpdated();
  });

  SecurityRule.prototype.clearAccessors = m.action(function() {
    this.accessors = [];
  });

  SecurityRule.prototype.checkNewAccessibleValue = m.action(function() {
    return true;
  });

  SecurityRule.prototype.updateAccessibleValue = m.action(function(accessibleValues) {
    var allValueItem = find(accessibleValue => accessibleValue.value === ACCESSIBLE_VALUE_OPTIONS[0].value, accessibleValues);
    if(!isEmpty(allValueItem)){
      this.accessibleValues = [ allValueItem.value ];
    }else{
      this.accessibleValues = uniq(map(item => item.value, accessibleValues));
    }
    this.markAsUpdated();
  });

  SecurityRule.prototype.updateAccessMode = m.action(function(accessMode) {
    this.accessMode = accessMode;
    this.markAsUpdated();
  });

  SecurityRule.prototype.updatePosition = m.action(function(position) {
    this.position = position;
    this.markAsUpdated();
  });

  SecurityRule.prototype.markAsUpdated = m.action(function() {
    if(this.state !== STATE.inserted){
      this.state = STATE.updated;
    }
  });

  SecurityRule.prototype.markAsInserted = m.action(function() {
    this.state = STATE.inserted;
  });

  SecurityRule.prototype.markAsDeleted = m.action(function() {
    this.state = STATE.deleted;
  });

  SecurityRule.prototype.isDeleted = function() {
    return this.state === STATE.deleted;
  };

  SecurityRule.prototype.isChanged = function() {
    return this.state === STATE.inserted || this.state === STATE.updated || this.state === STATE.deleted;
  };

  SecurityRule.prototype.clone = function(saveTempId) {
    var clone = new SecurityRule(m.toJS(this));
    if(saveTempId){
      clone.tempId = this.tempId;
    } else {
      clone.id = null;
      clone.state = STATE.inserted;
    }
    return clone;
  };

  SecurityRule.prototype.buildSaveData = function() {
    return {
      id: this.id,
      state: this.state,
      position: this.position,
      userGroup: this.userGroup,
      accessors: this.accessors,
      accessibleValues: this.accessibleValues,
      accessMode: this.accessMode
    };
  };

  module.exports = SecurityRule;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SecurityRule.js